import {ServicesTaggingEnum} from 'main/analytics/gaTagsEnum';
import {FeaturesEnum} from 'presentation/constants/featuresFlagEnum';
import {EndpointProps} from 'presentation/hooks/useGetEndpointUrl/types';
import IconNamesType from 'presentation/icons/IconNamesType';
import {ServicesTypesEnum} from '../../services/types';

type ServiceList = {
	category: CategoriesEnum;
	list: Service[];
	dataTagId?: ServicesTaggingEnum;
};

type Service = {
	route?: string;
	icon?: IconNamesType;
	imageSrc?: string;
	title: ServicesTitlesEnum | ExternalServicesTitlesEnum | ServicesCenterTitlesEnum;
	endpoint?: EndpointProps;
	disableCache?: boolean;
	isInversedColor?: boolean;
	show: boolean;
	openInIframe?: boolean;
	externalLink?: string;
	featureFlag?: FeaturesEnum;
	type: ServicesTypesEnum;
	dataTagId?: string;
	isBlob?: boolean;
	keywords?: string[];
	handleClick?: () => void;
};

export enum InvoicesNFLinksEnum {
	HAPVIDA = 'https://www.hapvida.com.br/pls/webhap/pk_nota_fiscal_ind.login_usuario_form',
	CCG = 'https://sigo.sh.srv.br/pls/webccg/pk_nota_fiscal_ind.login_usuario_form',
	NDIMINAS = 'https://sigo.sh.srv.br/pls/webmin/pk_nota_fiscal_ind.login_usuario_form',
	CLINIPAM = 'https://sigo.sh.srv.br/pls/webcli/pk_nota_fiscal_ind.login_usuario_form',
	NDI_SP = 'https://sigo.sh.srv.br/pls/webndi/pk_nota_fiscal_ind.login_usuario_form',
}

export enum CategoriesEnum {
	HEALTH_APPOINTMENTS = 'Consultas saúde',
	ODONTO_APPOINTMENTS = 'Consultas odonto',
	FINANCIAL_AND_DOCS = 'Financeiro e documentação',
	PERKS = 'Benefícios',
	PORTABILITY_AND_PERMANENCE = 'Portabilidade e permanência',
	SUPPORT = 'Atendimento',
	MANAGEMENT = 'Gestão de plano',
	NETWORK = 'Rede Credenciada',
	NOTREDAME_NETWORK = 'Rede Própria',
	TELEHEALTH = 'Telemedicina',
}

export enum ServicesCenterTitlesEnum {
	CHANGE_PLAN = 'Mudança de plano',
	CONTRACT_ADAPTATION = 'Adaptação de contratos',
	REGISTRATION_CHANGE = 'Alteração cadastral',
	DECLARATIONS_AND_DOCUMENTS = 'Declarações e documentos (emissão e 2ª via)',
	DEPENDENT_INCLUSION = 'Inclusão de dependentes',
	CHANGE_DUE_DATE = 'Alterar data de vencimento',
	CONTRACT_REACTIVATION = 'Reativação de contrato cancelado por inadimplência',
	CHANGE_PLAN_HOLDER = 'Alteração do titular do plano',
	PAD_ADHESION = 'Adesão ao PAD (Programa de Aposentados e Ex-funcionários)',
}

export enum ExternalServicesTitlesEnum {
	DEBT_SETTLEMENT_STATEMENT = 'Demonstrativo de quitação de débitos',
	PORTABILITY_CARD = 'Carta portabilidade',
	SERVICE_CENTER = 'Central de serviços',
	PIN_SS = 'PIN-SS',
	MY_HOSPITALIZATION = 'Minha internação',
	EXAM_RESULTS = 'Resultado de exames',
	AUTHORIZATION_REQUEST = 'Autorizações e solicitações',
	CONTRACT_ONLINE = 'Contrate Online',
	SUPPORT = 'Ouvidoria',
	STAY_LETTER = 'Carta de permanência',
	BENEFICIARY_DOCUMENT = 'Documentos e formulários',
	INVOICES = 'Notas fiscais',
	FINANCIAL_SUPPORT = 'Atendimento para faturas, negociações e 2ª via',
}

export enum ServicesTitlesEnum {
	MY_HOSPITALIZATION = 'Minha internação',
	HEALTH_GUIDE = 'Guia médico',
	NETWORK_PROVIDER_HEALTH = 'Rede de atendimento saúde',
	ODONTO_GUIDE = 'Guia odonto',
	NETWORK_PROVIDER_ODONTO = 'Rede de atendimento odonto',
	SALUDIA_NETWORK = 'Rede Saludia',
	FRANCHISES_TABLE = 'Tabela de franquias',
	REFUND_ODONTO = 'Reembolso odonto',
	BILLET = 'Boletos',
	INVOICES = 'Faturas',
	COPAYMENT_STATEMENT = 'Extrato de coparticipação',
	INCOME_TAX_STATEMENT = 'Demonstrativo de IR',
	PERKS_CLUB = 'Clube de Vantagens',
	ADDITIONAL_COVERAGE = 'Coberturas adicionais',
	RECOMMENDATION = 'Quem Indica',
	UNITS = 'Rede própria de atendimento',
	SERVICE_CHANNELS = 'Canais de atendimento',
	CONSULT_PROTOCOLS = 'Consulta de protocolos',
	TOKEN = 'Token',
	CUIDAE = 'Hapvida cuidaê',
	APPOINTMENT_BOOKING = 'Agendamento de consulta',
	EXAM_BOOKING = 'Agendamento de exame',
	ADVANCE_DIAGNOSTICS = 'Advance Diagnósticos',
	ODONTO_BOOKING = 'Agendamento de dentista',
	MY_REFERRALS = 'Meus encaminhamentos',
	EMERGENCY_TELEHEALTH = 'Pronto atendimento digital',
	TELEHEALTH_BOOKING = 'Agendamento de teleconsulta',
	REFUND = 'Reembolso saúde',
	CONSULT_REFUND = 'Consulta de reembolso',
	AUTHORIZATIONS_HEALTH = 'Autorizações saúde',
	AUTHORIZATIONS_ODONTO = 'Autorizações odonto',
	CONCIERGE = 'Concierge',
	NOTREDAME_CUIDAE = 'Cuidaê',
	EXAM_RESULTS = 'Resultado de exames',
	MY_APPOINTMENTS = 'Meus Agendamentos',
}

export type {Service, ServiceList};
